import { useEffect, useState } from 'react';
import { api } from '../../../lib/api';
import { Transaction } from '../../../types/transactions';

export function useTransactionDetail(id: string) {
  const [data, setData] = useState<Transaction | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.get<{ data: Transaction }>(`/transactions/${id}`);
      setData((res as any).data || (res as any));
    } catch (e: any) {
      setError(e.message || 'Failed to load');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return { data, loading, error, reload: load };
}
